import { render } from "./PopupAlert.vue?vue&type=template&id=b07d55be&scoped=true"
import script from "./PopupAlert.vue?vue&type=script&lang=js"
export * from "./PopupAlert.vue?vue&type=script&lang=js"

import "./PopupAlert.vue?vue&type=style&index=0&id=b07d55be&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07d55be"]])

export default __exports__